import { render, staticRenderFns } from "./ProcessRejected.vue?vue&type=template&id=780eacb9&scoped=true"
import script from "./ProcessRejected.ts?vue&type=script&lang=ts&external"
export * from "./ProcessRejected.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessRejected.vue?vue&type=style&index=0&id=780eacb9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780eacb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('780eacb9')) {
      api.createRecord('780eacb9', component.options)
    } else {
      api.reload('780eacb9', component.options)
    }
    module.hot.accept("./ProcessRejected.vue?vue&type=template&id=780eacb9&scoped=true", function () {
      api.rerender('780eacb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Alerts/components/ProcessTimerSection/ProcessRejected/ProcessRejected.vue"
export default component.exports